(function (angular, schoolwork12) {
    'use strict';
    angular.module(schoolwork12.app.k12DataManagement.name)
        .factory('k12DataMgmtSvc', ['$http', '$q', function ($http, $q) {

            var getClusterConfig = function (keycode, type) {
                console.info('In getClusterConfig service');
                console.info('Making a call to service');
                var getClusterConfig = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.k12DataManagement.endpoints.getK12DataManagementEndpoint + type,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    getClusterConfig = response.data;
                    deferred.resolve(getClusterConfig);
                    console.info('Got the cluster configuration list');
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var saveClusterConfig = function (keycode, ClusterConfig) {
                console.info('In saveClusterConfig service');
                console.info('Making a call to service');
                var getClusterConfig = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.k12DataManagement.endpoints.getK12DataManagementEndpoint + "/saveClusterConfig",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: ClusterConfig
                });
                request.then(function (response) {
                    getClusterConfig = response.data;
                    deferred.resolve(getClusterConfig);
                    console.info('Got the cluster configuration Saved');
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var deteleClusterConfig = function (keycode, clusterConfigList) {
                console.info('In deteleClusterConfig service');
                console.info('Making a call to service');
                var getClusterConfig = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.k12DataManagement.endpoints.getK12DataManagementEndpoint + "/deleteClusterConfig",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: clusterConfigList
                });
                request.then(function (response) {
                    getClusterConfig = response.data;
                    deferred.resolve(getClusterConfig);
                    console.info('Got the cluster configuration list deleted');
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getSystemConfigs = function (keycode) {
                console.info('In getSystemConfigs service');
                console.info('Making a call to service');
                var getSystemConfigurations = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.k12DataManagement.endpoints.getK12DataManagementEndpoint + '/systemConfiguration',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    getSystemConfigurations = response.data;
                    deferred.resolve(getSystemConfigurations);
                    console.info('Got the system configurations list');
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var deleteSystemConfig = function (keycode, systemConfig) {
                console.info('In deleteSystemConfig service');
                console.info('Making a call to service');
                var deferred = $q.defer();
                var serviceResponse;
                var request = $http({
                    method: 'DELETE',
                    url: schoolwork12.app.k12DataManagement.endpoints.getK12DataManagementEndpoint + "/systemConfiguration",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: systemConfig
                });
                request.then(function (response) {
                    serviceResponse = response.data;
                    deferred.resolve(serviceResponse);
                    console.info('Got the cluster configuration Saved');
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var saveSystemConfig = function (keycode, systemConfig) {
                console.info('In deleteSystemConfig service');
                console.info('Making a call to service');
                var deferred = $q.defer();
                var serviceResponse;
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.k12DataManagement.endpoints.getK12DataManagementEndpoint + "/systemConfiguration",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: systemConfig
                });
                request.then(function (response) {
                    serviceResponse = response.data;
                    deferred.resolve(serviceResponse);
                    console.info('Got the cluster configuration Saved');
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            return {
                getClusterConfig: getClusterConfig,
                saveClusterConfig: saveClusterConfig,
                deteleClusterConfig: deteleClusterConfig,
                getSystemConfigs: getSystemConfigs,
                deleteSystemConfig: deleteSystemConfig,
                saveSystemConfig: saveSystemConfig
            };
        }

        ]);
}(angular, schoolwork12));
